import { centerable as i } from "../decorators/centerable.js";
import { uploadable as l } from "../decorators/uploadable.js";
import { BLOCK_CLASSES as o } from "../../constants.js";
import { defineAttrs as a } from "../../utils/typed-attrs.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const s = a({
  type: { default: "videoFile" },
  duration: { default: 0 },
  url: { default: "" },
  thumbnailUrl: { default: "" },
  captions: { default: "" }
}), b = i(
  l({
    inline: !1,
    draggable: !0,
    attrs: s,
    group: "block",
    parseDOM: [
      {
        tag: ".intercom-interblocks-video-file",
        getAttrs(e) {
          const t = e.querySelector("a"), r = e.querySelector("img");
          return {
            thumbnailUrl: r?.getAttribute("src") ?? "",
            url: t?.getAttribute("href") ?? "",
            captions: r?.getAttribute("alt") ?? ""
          };
        }
      },
      {
        tag: ".embercom-prosemirror-composer-block-container.embercom-prosemirror-composer-video video",
        getAttrs(e) {
          const t = e.querySelector("source");
          return {
            thumbnailUrl: e.getAttribute("poster") ?? "",
            url: t?.getAttribute("src") ?? "",
            captions: t?.getAttribute("alt") ?? ""
          };
        }
      }
    ],
    toDOM(e) {
      const t = e.attrs;
      return [
        "div",
        {
          class: `${o.blockContainer} ${o.video}`
        },
        [
          "video",
          {
            class: "block-video-file-player",
            controls: "pause play mute",
            poster: t.thumbnailUrl,
            style: "display: block; width: 100%; height: 100%;"
          },
          [
            "source",
            {
              src: t.url,
              alt: t.captions
            }
          ]
        ]
      ];
    }
  })
);
export {
  b as videoFileSpec
};
